/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { createAsyncAction } from 'Helpers/redux'
import { APP } from 'Configs/App'
import { apiCall } from './api'

export const ORDER_PAYOUT = createAsyncAction('ORDER_PAYOUT')
export const orderPayout = (amount: number, callback: () => void) =>
  apiCall({
    method: 'post',
    endpoint: `${APP.TIKTOK_SERVER}/payout/transferwise`,
    query: {
      amount,
    },
    types: ORDER_PAYOUT,
    callback,
  })

export const GET_TRANSACTIONS = createAsyncAction('GET_TRANSACTIONS')
export const getAllTransactions = (pageNumber: number) =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/payout/balance-history-page?pageNumber=${pageNumber}&pageSize=20`,
    types: GET_TRANSACTIONS,
  })

// export const GET_TRANSACTIONS = createAsyncAction('GET_TRANSACTIONS')
// export const getAllTransactions = (page: number) =>
//   apiCall({
//     method: 'get',
//     endpoint: `/curator/transactions/${page}`,
//     types: GET_TRANSACTIONS,
//   })

export const GET_TRANSACTIONS_DETAILS = createAsyncAction(
  'GET_TRANSACTIONS_DETAILS'
)
export const getTransactionsDetails = () =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/payout/balance-details`,
    types: GET_TRANSACTIONS_DETAILS,
  })
